import Component from './instagram_next_auth.vue'
export default Component
